import {
  cn,
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@workspace/frontend-ui";
import languageCodeToTitleMapper from "./languageCodeToTitleMapper";
import useLanguageSwitcher from "./useLanguageSwitcher";

type Props = {
  optionClassName?: string;
};

const LanguageSwitcher: FC<Props> = ({ optionClassName }) => {
  const { handleChange, languages, router } = useLanguageSwitcher();

  return (
    <Select value={router.locale} onValueChange={handleChange}>
      <SelectTrigger
        data-testid="language-switcher"
        className="w-full text-muted-foreground"
        size="lg"
      >
        <SelectValue className="text-base">
          {languageCodeToTitleMapper[router.locale]}
        </SelectValue>
      </SelectTrigger>
      <SelectContent className={cn("z-50 w-72", optionClassName)}>
        {languages.map((code) => (
          <SelectItem
            hideIndicator
            key={code}
            value={code}
            className="h-10 data-checked:bg-accent"
          >
            {languageCodeToTitleMapper[code]}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
};

export default LanguageSwitcher;
